export default __webpack_public_path__ + "static/media/PrintButtonSVG.7928cacb.svg";